import React from "react";
import { fetchAllTextFromWord, fetchRequestData } from "../Utils/CommonFunctions";
import { Spinner } from "office-ui-fabric-react";
import { GenerateAISummary } from "./Generators/AIContractSummary";

const ContractSummary = ({ RequestData, summaryState, setSummaryState }) => {

  React.useEffect(() => {
    getSummaryData();
  }, []);
  const getSummaryData = async () => {
   
    try {
      const response: any = await fetchRequestData(RequestData?.Guid_ID);
      const rawSummary = JSON.parse(response[0]?.ContractSummary||"{}")?.SummaryData;

      if (rawSummary) {
        const Summary = rawSummary.replace(/\\n/g, "<br/>");
        setSummaryState({ summary: Summary, isLoading: false });
      } else if(!summaryState?.summary){
         const documentText = await fetchAllTextFromWord();
        const Summary = await GenerateAISummary(documentText, RequestData['Draft_Type'], RequestData?.['Contract_Start_Date'], RequestData?.['Contract_End_Date'])
        setSummaryState({ summary: Summary, isLoading: false });
        setSummaryState((prev) => ({ ...prev, isLoading: false }));
      }
    } catch (error) {
      console.error("Failed to fetch contract summary:", error);
    }
  };

  return (
    <div>
      {summaryState.isLoading ? (
        <Spinner style={{ height: "70vh" }} label="Processing contract summary..." />
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <div style={{ fontWeight: "bold" }}>Contract Summary:</div>
          <div style={{lineHeight:'22px'}} dangerouslySetInnerHTML={{ __html: summaryState.summary }} />
        </div>
      )}
    </div>
  );
};

export default ContractSummary;
